import { ExclamationCircleOutlined, MinusOutlined, PlusOutlined } from "@ant-design/icons";
import DatePicker from "../../../../../components/inputs/MomentDatePicker";
import {
  Alert,
  Button,
  Checkbox,
  Collapse,
  Form,
  Input,
  Modal,
  Select,
  Tag,
  Typography,
  message,
} from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { serverUrl } from "../../../../../nestserver";
import edit from "../../../../../resources/edit.svg";
import { numberInputGuard } from "../../../../../components/inputs/numberInputGuard";
const { Option } = Select;
const { Panel } = Collapse;

function tagRender(props) {
  const { label, closable, onClose } = props;
  const onPreventMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };
  return (
    <Tag
      onMouseDown={onPreventMouseDown}
      closable={closable}
      onClose={onClose}
      style={{ margin: 5 }}
      className="flex items-center"
    >
      {label}
    </Tag>
  );
}
const GenderSelect = ({ value, onChange }) => {
  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder="Select Gender"
    >
      <Option value="male">Male</Option>
      <Option value="female">Female</Option>
      <Option value="others">Other</Option>
    </Select>
  );
};
const BloodGroupSelect = ({ value, onChange }) => {
  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder="Select Blood Group"
      allowClear
    >
      <Option value="A+">A+</Option>
      <Option value="B+">B+</Option>
      <Option value="O+">O+</Option>
      <Option value="A-">A-</Option>
      <Option value="B-">B-</Option>
      <Option value="O-">O-</Option>
      <Option value="AB+">AB+</Option>
      <Option value="AB-">AB-</Option>
    </Select>
  );
};

function StudentSetting({ data, existingSiblings }) {
  const { Title } = Typography;
  const { Option } = Select;
  const { confirm } = Modal;
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const [emailDisable, setEmailDisable] = useState(true);
  const [accommodationCheckbox, setAccommodationCheckbox] = useState(false);
  const [classId, setClassId] = useState(null);
  const [subjectListing, setSubjectListing] = useState({
    subjects: [],
    co_curricular: [],
    languages: [],
  });

  const dateFormat = "YYYY-MM-DD";

  const [transportationCheckbox, setTransportationCheckbox] = useState(false);
  const [selectedZoneId, setSelectedZoneId] = useState(null);
  const [selectedDestId, setSelectedDestId] = useState(null);
  const [routeId, setRouteId] = useState(null);
  const [siblingFields, setSiblingFields] = useState([{}]);
  const handleAddSibling = () => {
    setSiblingFields([...siblingFields, {}]);
  };
  const handleRemoveSibling = (index) => {
    const updated = [...siblingFields];
    updated.splice(index, 1);
    setSiblingFields(updated.length ? updated : [{}]);
  };

  const fetchBillingZones = async () => {
    const res = await axios({
      method: "get",
      url: `${serverUrl}/admin/transport-billing-zone/list`,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data?.result || [];
  };
  const billingZones = useQuery("transport-billing-zones", fetchBillingZones);

  const selectedZone = useMemo(() => {
    if (!billingZones.data || !selectedZoneId) return null;
    return billingZones.data.find((z) => z._id === selectedZoneId) || null;
  }, [billingZones.data, selectedZoneId]);

  const selectedDest = useMemo(() => {
    if (!selectedZone || !selectedDestId) return null;
    return (selectedZone.destinations || []).find(
      (d) => d._id === selectedDestId
    ) || null;
  }, [selectedZone, selectedDestId]);

  const routes = useQuery(["school-routes"], async () => {
    const headers = { Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}` };
    const [v1Res, v2Res] = await Promise.all([
      axios.get(`${serverUrl}/routes`, { headers }),
      axios.get(`${serverUrl}/routes/v2`, { headers }),
    ]);
    const v1Data = v1Res.data?.result?.data || [];
    const v2Data = v2Res.data?.result?.data || [];
    return [
      ...v1Data.map((r) => ({ ...r, _version: "v1" })),
      ...v2Data.map((r) => ({ ...r, _version: "v2" })),
    ];
  });

  const routesDetail = useQuery(
    ["school-route-stops", routeId],
    async () => {
      const headers = { Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}` };
      const routeInList = (routes.data || []).find((r) => r._id === routeId);
      const url = routeInList?._version === "v2"
        ? `${serverUrl}/routes/v2/${routeId}`
        : `${serverUrl}/routes/${routeId}`;
      const res = await axios.get(url, { headers });
      return res.data?.result?.data?.route_map || [];
    },
    { enabled: !!routeId }
  );

  const fetchClasses = async () => {
    const res = await axios({
      method: "get",
      url: serverUrl + "/classes",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });

    return res.data;
  };
  const classes = useQuery("classes", fetchClasses);

  async function fetchSubjects() {
    const res = await axios({
      method: "get",
      url: serverUrl + "/subjects/",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });

    return res.data;
  }
  const subjects = useQuery("subjects", fetchSubjects);

  const onFinish = async (values) => {
    try {
      const existingSiblings = siblingFields
        .filter((_, index) => values[`sibling_name_${index}`] || values[`sibling_student_id_${index}`])
        .map((_, index) => ({
          name: values[`sibling_name_${index}`] || "",
          student_id: values[`sibling_student_id_${index}`] || "",
          class: values[`sibling_class_${index}`] || undefined,
        }));

      const studentData = {
        first_name: values?.first_name,
        last_name: values?.last_name,
        class: values?.class,
        nationality: values?.nationality,
        birth_place: values?.birth_place,
        religion: values?.religion,
        category: values?.category,
        ethnicity: values?.ethnicity,
        aadhar: values?.aadhar,
        subjects: [...subjectListing.subjects],
        languages: values?.language || [],
        co_curricular: values?.curricular || [],
        admission_number: values?.admissionNumber,
        gender: values?.gender,
        phone: values?.phone,
        roll_number: values?.rollNumber,
        admission_date: moment(values?.admissionDate).format("YYYY-MM-DD"),
        dob: moment(values?.dob).format("YYYY-MM-DD"),
        blood_group: values?.blood_group,
        is_transportation_required: transportationCheckbox,
        is_accommodation_required: accommodationCheckbox,
        transport_zone_id: values?.transport_zone_id || null,
        transport_destination_id: values?.transport_destination_id || null,
        route_id: values?.route_id || null,
        route_entry_point_id: values?.route_entry_point_id || null,
        primary_contact: {
          first_name: values?.primary_contact_first_name,
          last_name: values?.primary_contact_last_name,
          relation: values?.primary_contact_relation,
          contact: values?.primary_contact_phone,
          email: values?.primary_contact_email,
          aadhar: values?.primary_contact_aadhar,
          education: values?.primary_contact_education,
          occupation: values?.primary_contact_occupation,
          annual_income: values?.primary_contact_annual_income,
          address: values?.primary_contact_address,
          emergency_contact: values?.primary_emergency_contact,
        },
        secondary_contact: {
          first_name: values?.secondary_contact_first_name,
          last_name: values?.secondary_contact_last_name,
          relation: values?.secondary_contact_relation,
          contact: values?.secondary_contact_phone,
          email: values?.secondary_contact_email,
        },
        // Mother's details are independent of primary/secondary contact —
        // mirrors Application.mother_name and its sibling fields.
        mother_name: values?.mother_name,
        mother_phone: values?.mother_phone,
        mother_email: values?.mother_email,
        mother_aadhar: values?.mother_aadhar,
        mother_education: values?.mother_education,
        mother_occupation: values?.mother_occupation,
        mother_annual_income: values?.mother_annual_income,
        existing_siblings: existingSiblings,
      };

      const userData = {
        blocked: values.blocked,
        email: values.email,
      };

      const updatePromises = [];

      if (values.password) {
        const loginData = {
          email: values.email,
          password: values.password,
        };

        updatePromises.push(
          axios({
            method: "patch",
            url: serverUrl + "/users/password/" + data?._id,
            data: loginData,
            headers: {
              Authorization: `Bearer ${window.localStorage.getItem(
                "jwt-token",
              )}`,
            },
          }),
        );
      }

      updatePromises.push(
        axios.patch(
          serverUrl + "/students/" + (data.students?._id || data.student?._id),
          studentData,
          {
            headers: {
              Authorization: `Bearer ${window.localStorage.getItem(
                "jwt-token",
              )}`,
            },
          },
        ),
      );

      updatePromises.push(
        axios.patch(serverUrl + "/users/" + data._id, userData, {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
          },
        }),
      );

      await Promise.all(updatePromises);

      message.success("Profile updated successfully");

      if (accommodationCheckbox && !data?.is_accommodation_required) {
        message.info(
          "Accommodation enabled — please apply the fee template to generate the accommodation fee for this student.",
          6,
        );
      }

      queryClient.invalidateQueries(["student", data?._id]);
    } catch (err) {
      console.error(err);
      if (err?.response?.data?.message) {
        message.error(err.response.data.message);
      } else {
        message.error("An error occurred while updating");
      }
    }
  };

  const confirmDelete = () => {
    confirm({
      title: "Do you want to delete the student?",
      icon: <ExclamationCircleOutlined />,
      okText: "Yes",
      cancelText: "No",
      onOk() {
        deleteUser();
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const deleteUser = () => {
    axios({
      method: "delete",
      url: serverUrl + "/users/" + data?._id,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    }).then((res) => {
      message.success("Deleted");
      navigate(`/dashboard/admin/menu/student`);
    });
  };

  useEffect(() => {
    if (data?.student?.class) {
      setClassId(data?.student?.class?._id);
    }
  }, [data?.student?.class]);

  useEffect(() => {
    if (classId && classId !== data?.student?.class?._id) {
      form?.setFieldsValue({
        ...form?.getFieldsValue(),
        subjects: [],
      });
    }
  }, [classId, data?.student?.class?._id, form]);
  const validateAlphabetsOnly = (_, value) => {
    const regex = /^[a-zA-Z\s]*$/;
    if (!regex.test(value)) {
      return Promise.reject("Please enter alphabets only");
    }
    return Promise.resolve();
  };
  useEffect(() => {
    if (classId && classId !== data?.student?.class?._id) {
      form.setFieldsValue({
        language: [],
        curricular: [],
      });
    }
  }, [classId, data?.student?.class?._id, form]);
  useEffect(() => {
    if (classId && subjects?.isSuccess) {
      const mandatorySubjects = subjects?.data?.filter(
        (s) => s?.class?._id === classId && s?.is_mandatory,
      );
      const coCurricularSubjects = subjects?.data?.filter(
        (s) => s?.class?._id === classId && s?.is_co_curricular,
      );
      const languageSubjects = subjects?.data?.filter(
        (s) => s?.class?._id === classId && s?.is_language,
      );

      setSubjectListing({
        subjects: mandatorySubjects?.map((s) => s?._id),
        co_curricular: coCurricularSubjects?.map((s) => s?._id),
        languages: languageSubjects?.map((s) => s?._id),
      });
    }
  }, [classId, subjects?.data, subjects?.isSuccess]);

  useEffect(() => {
    if (existingSiblings?.length) {
      setSiblingFields(existingSiblings);
    }
  }, [existingSiblings]);

  const siblingInitialValues = useMemo(() => {
    const values = {};
    (existingSiblings?.length ? existingSiblings : [{}]).forEach(
      (sibling, index) => {
        values[`sibling_name_${index}`] = sibling?.name;
        values[`sibling_student_id_${index}`] = sibling?.student_id;
        values[`sibling_class_${index}`] = sibling?.class?._id;
      },
    );
    return values;
  }, [existingSiblings]);

  useEffect(() => {
    form.setFieldsValue({
      email: data?.email,
      first_name: data?.student?.first_name,
      last_name: data?.student?.last_name,
      class: data?.student?.class?._id,
      subjects: data?.student?.subjects.map((s) => s._id),
      blocked: data?.blocked,
      nationality: data?.student?.nationality,
      birth_place: data?.student?.birth_place,
      religion: data?.student?.religion,
      category: data?.student?.category,
      ethnicity: data?.student?.ethnicity,
      aadhar: data?.student?.aadhar,
      gender: data?.student?.gender,
      phone: data?.phone,
      rollNumber: data?.student?.roll_number,
      unique_id: data?.student?.unique_id,
      blood_group: data?.student?.blood_group,
      language: data?.student?.languages?.map((lang) => lang._id),
      curricular: data?.student?.co_curricular?.map((cur) => cur._id),
      admissionNumber: data?.student ? data.student.admission_number : null,
      admissionDate:
        data?.student?.admission_date &&
        moment(data?.student?.admission_date, dateFormat),
      dob: data?.student?.dob && moment(data?.student?.dob, dateFormat),
      primary_contact_first_name: data?.student?.primary_contact?.first_name,
      primary_contact_last_name: data?.student?.primary_contact?.last_name,
      primary_contact_relation: data?.student?.primary_contact?.relation,
      primary_contact_phone: data?.student?.primary_contact?.contact,
      primary_contact_email: data?.student?.primary_contact?.email,
      primary_contact_aadhar: data?.student?.primary_contact?.aadhar,
      primary_contact_education: data?.student?.primary_contact?.education,
      primary_contact_occupation: data?.student?.primary_contact?.occupation,
      primary_contact_annual_income:
        data?.student?.primary_contact?.annual_income,
      primary_contact_address: data?.student?.primary_contact?.address,
      primary_emergency_contact:
        data?.student?.primary_contact?.emergency_contact,
      secondary_contact_first_name:
        data?.student?.secondary_contact?.first_name,
      secondary_contact_last_name: data?.student?.secondary_contact?.last_name,
      secondary_contact_relation: data?.student?.secondary_contact?.relation,
      secondary_contact_phone: data?.student?.secondary_contact?.contact,
      secondary_contact_email: data?.student?.secondary_contact?.email,
      mother_name: data?.student?.mother_name,
      mother_phone: data?.student?.mother_phone,
      mother_email: data?.student?.mother_email,
      mother_aadhar: data?.student?.mother_aadhar,
      mother_education: data?.student?.mother_education,
      mother_occupation: data?.student?.mother_occupation,
      mother_annual_income: data?.student?.mother_annual_income,
      is_transportation_required: data?.is_transportation_required,
      is_accommodation_required: data?.is_accommodation_required,
      transport_zone_id: data?.transport_zone_id?._id || data?.transport_zone_id || undefined,
      transport_destination_id: data?.transport_destination_id || undefined,
      route_id: data?.route_id?._id || data?.route_id || undefined,
      route_entry_point_id: data?.route_entry_point_id?._id || data?.route_entry_point_id || undefined,
      ...siblingInitialValues,
    });
    setSelectedZoneId(data?.transport_zone_id?._id || data?.transport_zone_id || null);
    setSelectedDestId(data?.transport_destination_id || null);
    setRouteId(data?.route_id?._id || data?.route_id || null);
    setTransportationCheckbox(data?.is_transportation_required);
    setAccommodationCheckbox(data?.is_accommodation_required);
  }, [data, form, siblingInitialValues]);

  const hasGuardianData = Boolean(
    data?.student?.secondary_contact?.first_name ||
      data?.student?.secondary_contact?.last_name ||
      data?.student?.secondary_contact?.contact,
  );

  return (
    <>
      <div className="pt-8">
        <div
          style={{ borderRadius: "10px", color: "#616161" }}
          className=" bg-white drop-shadow-md p-8 w-full "
        >
          {data && (
            <Form
              form={form}
              layout="vertical"
              name="basic"
              initialValues={{
                email: data?.email,
                first_name: data?.student?.first_name,
                last_name: data?.student?.last_name,
                class: data?.student?.class?._id,
                subjects: data?.student?.subjects.map((s) => s._id),
                blocked: data?.blocked,
                nationality: data?.student?.nationality,
                birth_place: data?.student?.birth_place,
                religion: data?.student?.religion,
                category: data?.student?.category,
                ethnicity: data?.student?.ethnicity,
                aadhar: data?.student?.aadhar,
                gender: data?.student?.gender,
                phone: data?.phone,
                rollNumber: data?.student?.roll_number,
                unique_id: data?.student?.unique_id,
                blood_group: data?.student?.blood_group,
                language: data?.student?.languages?.map((lang) => lang._id),
                curricular: data?.student?.co_curricular?.map((cur) => cur._id),
                admissionNumber: data?.student
                  ? data.student.admission_number
                  : null,
                admissionDate:
                  data?.student?.admission_date &&
                  moment(data?.student?.admission_date, dateFormat),
                dob:
                  data?.student?.dob && moment(data?.student?.dob, dateFormat),
                primary_contact_first_name:
                  data?.student?.primary_contact?.first_name,
                primary_contact_last_name:
                  data?.student?.primary_contact?.last_name,
                primary_contact_relation:
                  data?.student?.primary_contact?.relation,
                primary_contact_phone: data?.student?.primary_contact?.contact,
                primary_contact_email: data?.student?.primary_contact?.email,
                primary_contact_aadhar: data?.student?.primary_contact?.aadhar,
                primary_contact_education:
                  data?.student?.primary_contact?.education,
                primary_contact_occupation:
                  data?.student?.primary_contact?.occupation,
                primary_contact_annual_income:
                  data?.student?.primary_contact?.annual_income,
                primary_contact_address:
                  data?.student?.primary_contact?.address,
                primary_emergency_contact:
                  data?.student?.primary_contact?.emergency_contact,
                secondary_contact_first_name:
                  data?.student?.secondary_contact?.first_name,
                secondary_contact_last_name:
                  data?.student?.secondary_contact?.last_name,
                secondary_contact_relation:
                  data?.student?.secondary_contact?.relation,
                secondary_contact_phone:
                  data?.student?.secondary_contact?.contact,
                secondary_contact_email:
                  data?.student?.secondary_contact?.email,
                mother_name: data?.student?.mother_name,
                mother_phone: data?.student?.mother_phone,
                mother_email: data?.student?.mother_email,
                mother_aadhar: data?.student?.mother_aadhar,
                mother_education: data?.student?.mother_education,
                mother_occupation: data?.student?.mother_occupation,
                mother_annual_income: data?.student?.mother_annual_income,
                ...siblingInitialValues,
              }}
              onFinish={onFinish}
              autoComplete="off"
            >
              <div className="grid grid-cols-2 gap-x-4">
                <Form.Item label="Student Id" name="unique_id" className="w-full">
                  <Input className="w-full" readOnly />
                </Form.Item>
                <Form.Item
                  label="Password"
                  name="password"
                  rules={[
                    {
                      min: 6,
                      message: "Password must be at least 6 characters long!",
                    },
                  ]}
                >
                  <div className="flex flex-row items-center space-x-8">
                    <Input.Password placeholder="********" className="w-full" />
                    <div>
                      {" "}
                      <img
                        src={edit}
                        alt="edit-button"
                        className="cursor-pointer"
                      />{" "}
                    </div>
                  </div>
                </Form.Item>
              </div>

              <Collapse
                expandIconPosition="right"
                bordered={false}
                expandIcon={({ isActive }) =>
                  isActive ? (
                    <MinusOutlined className="text-primary-500" />
                  ) : (
                    <PlusOutlined />
                  )
                }
                className="student-setting-collapse"
                defaultActiveKey={[
                  "student",
                  "address",
                  "siblings",
                  "transport",
                  "father",
                  "mother",
                  "guardian",
                ]}
              >
                <Panel header="1. Student Details" key="student">
                  <div className="grid grid-cols-2 gap-x-4">
                    <Form.Item
                      label="First Name"
                      name="first_name"
                      rules={[
                        {
                          required: true,
                          message: "Please input your First Name!",
                        },
                        {
                          validator: validateAlphabetsOnly,
                        },
                      ]}
                    >
                      <Input className="w-full " />
                    </Form.Item>
                    <Form.Item
                      label="Last Name"
                      name="last_name"
                      rules={[
                        {
                          required: true,
                          message: "Please input your Last Name!",
                        },
                        {
                          validator: validateAlphabetsOnly,
                        },
                      ]}
                    >
                      <Input className="w-full " />
                    </Form.Item>
                    <div className="flex flex-row items-center space-x-8 w-full">
                      <Form.Item
                        label="Email Address"
                        name="email"
                        className="w-full"
                      >
                        <Input disabled={emailDisable} />
                      </Form.Item>
                      <div>
                        <img
                          src={edit}
                          alt="edit-button"
                          className="cursor-pointer"
                          onClick={() => setEmailDisable(false)}
                        />{" "}
                      </div>
                    </div>
                    <div className="pb-2">
                      <Form.Item
                        label="Class"
                        name="class"
                        className="w-full"
                        rules={[
                          {
                            required: true,
                            message: "Please select a class",
                          },
                        ]}
                      >
                        <Select
                          showSearch
                          showArrow
                          placeholder="Select Class"
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          filterSort={(optionA, optionB) =>
                            optionA.children
                              .toLowerCase()
                              .localeCompare(optionB.children.toLowerCase())
                          }
                          className="w-full bg-gray-300"
                          style={{
                            border: "6px",
                            backgroundColor: "#EBEBEB",
                          }}
                          onChange={(e) => setClassId(e)}
                        >
                          {classes.isSuccess &&
                            classes?.data?.map((data) => {
                              return (
                                <Option key={data._id} value={data._id}>
                                  {data.name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                    {classId && (
                      <>
                        <div>
                          <div className="pb-2"> Mandatory</div>
                          <div className="flex fle flex-wrap gap-3 pb-4">
                            {subjects.isSuccess &&
                              subjects?.data
                                ?.filter(
                                  (s) =>
                                    s.class?._id === classId &&
                                    s.is_mandatory === true,
                                )
                                ?.map((data) => (
                                  <div
                                    key={data._id}
                                    className="bg-gray-200 px-4 py-2 rounded-md text-gray-700 iskool-friends-card capitalize"
                                  >
                                    {data.name}
                                  </div>
                                ))}
                          </div>
                        </div>

                        <Form.Item name="language" label="Languages">
                          <Select
                            mode="multiple"
                            showArrow
                            tagRender={tagRender}
                            placeholder="Select language"
                            style={{
                              border: "6px",
                              backgroundColor: "#EBEBEB",
                            }}
                            className="w-full"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {subjects?.isSuccess &&
                              subjects?.data
                                ?.filter(
                                  (s) =>
                                    s?.class?._id === classId &&
                                    s?.is_language === true &&
                                    s?._id !== null,
                                )
                                ?.map((data) => (
                                  <Option key={data._id} value={data._id}>
                                    {data?.name}
                                  </Option>
                                ))}
                          </Select>
                        </Form.Item>

                        <Form.Item name="curricular" label="Co-Curricular">
                          <Select
                            mode="multiple"
                            showArrow
                            tagRender={tagRender}
                            placeholder="Select co-Curricular"
                            style={{
                              border: "6px",
                              backgroundColor: "#EBEBEB",
                            }}
                            className="w-full"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {subjects.isSuccess &&
                              subjects?.data
                                ?.filter(
                                  (s) =>
                                    s?.class?._id === classId &&
                                    s?.is_co_curricular === true &&
                                    s?._id !== null,
                                )
                                ?.map((data) => (
                                  <Option key={data._id} value={data._id}>
                                    {data?.name}
                                  </Option>
                                ))}
                          </Select>
                        </Form.Item>
                      </>
                    )}
                    <Form.Item
                      name="dob"
                      label="Date Of Birth"
                      rules={[
                        {
                          required: true,
                          message: "Date of Birth  is required",
                        },
                      ]}
                      className="w-full"
                    >
                      <DatePicker
                        format="DD-MM-YYYY"
                        placeholder="Please select your date of birth"
                        disabledDate={(current) =>
                          current && current > moment().endOf("day")
                        }
                        className="w-full"
                      />
                    </Form.Item>
                    <Form.Item
                      name="gender"
                      label="Gender"
                      rules={[
                        {
                          required: true,
                          message: "Gender is required",
                        },
                      ]}
                      className="w-30"
                    >
                      <GenderSelect />
                    </Form.Item>
                    <Form.Item
                      name="admissionDate"
                      label="Admission Date"
                      rules={[
                        {
                          required: true,
                          message: "Admission date  is required",
                        },
                      ]}
                      className="w-30"
                    >
                      <DatePicker
                        format="DD-MM-YYYY"
                        placeholder="Please select"
                        disabledDate={(current) =>
                          current && current > moment().endOf("day")
                        }
                        className="w-full"
                      />
                    </Form.Item>
                    <Form.Item
                      name="admissionNumber"
                      label="Admission Number"
                      className="w-30"
                      getValueFromEvent={(e) => e.target.value}
                      rules={[
                        {
                          required: true,
                          message: "Admission number  is required",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name="aadhar"
                      label="Aadhar"
                      className="w-30"
                      rules={[
                        {
                          pattern: /^[0-9]{12}$/,
                          message: "Please enter a valid 12-digit Number!",
                        },
                      ]}
                      getValueFromEvent={(e) => e.target.value.slice(0, 12)}
                    >
                      <Input maxLength={12} type="number" min={0} {...numberInputGuard} />
                    </Form.Item>
                    <Form.Item label="Roll Number" name="rollNumber">
                      <Input className="w-full " />
                    </Form.Item>
                    <Form.Item
                      name="phone"
                      label="Phone"
                      className="w-30"
                      rules={[
                        {
                          pattern: /^[0-9]{10}$/,
                          message: "Please enter a valid 10-digit phone number!",
                        },
                      ]}
                      getValueFromEvent={(e) => e.target.value.slice(0, 10)}
                    >
                      <Input type="number" maxLength={10} min={0} {...numberInputGuard} />
                    </Form.Item>
                    <Form.Item
                      name="birth_place"
                      label="Birth Place"
                      className="w-30"
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name="category"
                      label="Category"
                      className="w-30"
                      rules={[
                        {
                          validator: validateAlphabetsOnly,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name="religion"
                      label="Religion"
                      className="w-30"
                      rules={[
                        {
                          validator: validateAlphabetsOnly,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name="nationality"
                      label="Nationality"
                      className="w-30"
                      rules={[
                        {
                          required: true,
                          message: "Nationality is required",
                        },
                        {
                          validator: validateAlphabetsOnly,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item name="ethnicity" label="Ethnicity" className="w-30">
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name="blood_group"
                      label="Blood Group"
                      className="w-30"
                    >
                      <BloodGroupSelect />
                    </Form.Item>
                  </div>
                </Panel>

                <Panel header="2. Address & Emergency Contact" key="address">
                  <div className="grid grid-cols-2 gap-x-4">
                    <Form.Item
                      name="primary_contact_address"
                      label="Address"
                      className="w-30"
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name="primary_emergency_contact"
                      label="Emergency Contact"
                      className="w-30"
                      rules={[
                        {
                          pattern: /^[0-9]{10}$/,
                          message: "Please enter a valid 10-digit phone number!",
                        },
                      ]}
                      getValueFromEvent={(e) => e.target.value.slice(0, 10)}
                    >
                      <Input type="number" maxLength={10} min={0} {...numberInputGuard} />
                    </Form.Item>
                  </div>
                </Panel>

                <Panel header="3. Siblings" key="siblings">
                  {siblingFields.map((field, index) => (
                    <div
                      className="grid grid-cols-4 gap-x-4 items-start"
                      key={index}
                    >
                      <Form.Item
                        name={`sibling_name_${index}`}
                        label="Name"
                        className="w-30"
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item
                        name={`sibling_student_id_${index}`}
                        label="Student Id"
                        className="w-30"
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item
                        name={`sibling_class_${index}`}
                        label="Class"
                        className="w-30"
                      >
                        <Select
                          showSearch
                          showArrow
                          placeholder="Select Class"
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          className="w-full bg-gray-300"
                          style={{
                            border: "6px",
                            backgroundColor: "#EBEBEB",
                          }}
                        >
                          {classes.isSuccess &&
                            classes?.data?.map((data) => (
                              <Option key={data._id} value={data._id}>
                                {data.name}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                      {siblingFields.length > 1 && (
                        <Button
                          danger
                          type="text"
                          className="mt-8"
                          onClick={() => handleRemoveSibling(index)}
                        >
                          Remove
                        </Button>
                      )}
                    </div>
                  ))}
                  <Button onClick={handleAddSibling}>Add Sibling</Button>
                </Panel>

                <Panel
                  header="4. Transportation & Accommodation"
                  key="transport"
                >
                  <Title level={4} className="admission-subheading">
                    Transportation
                  </Title>
                  <Form.Item
                    name="is_transportation_required"
                    valuePropName="checked"
                  >
                    <Checkbox
                      onChange={(e) => {
                        setTransportationCheckbox(e.target.checked);
                        form.resetFields(["transport_zone_id", "transport_destination_id", "route_id", "route_entry_point_id"]);
                        setSelectedZoneId(null);
                        setSelectedDestId(null);
                        setRouteId(null);
                      }}
                      checked={transportationCheckbox}
                    >
                      Transportation require?
                    </Checkbox>
                  </Form.Item>
                  {transportationCheckbox && !data?.is_transportation_required && (
                    <Alert
                      type="info"
                      showIcon
                      message="Action required after saving"
                      description="After saving these changes, go to the Fee Template and apply a transportation template to generate the transportation fee for this student."
                      style={{ marginBottom: 16 }}
                    />
                  )}
                  {transportationCheckbox && (
                    <div className="admission-form">
                      <Form.Item
                        label="Transport Zone"
                        name="transport_zone_id"
                        className="w-full"
                      >
                        <Select
                          showSearch
                          showArrow
                          allowClear
                          placeholder="Select Transport Zone"
                          className="w-full bg-gray-300"
                          style={{ border: "6px", backgroundColor: "#EBEBEB" }}
                          loading={billingZones.isLoading}
                          onChange={(value) => {
                            setSelectedZoneId(value || null);
                            setSelectedDestId(null);
                            form.resetFields(["transport_destination_id"]);
                          }}
                        >
                          {(billingZones.data || []).map((zone) => (
                            <Option key={zone._id} value={zone._id}>
                              {zone.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        label="Destination"
                        name="transport_destination_id"
                        className="w-full"
                      >
                        <Select
                          showSearch
                          showArrow
                          allowClear
                          placeholder={selectedZoneId ? "Select destination" : "Select a zone first"}
                          className="w-full bg-gray-300"
                          style={{ border: "6px", backgroundColor: "#EBEBEB" }}
                          disabled={!selectedZoneId}
                          onChange={(value) => setSelectedDestId(value || null)}
                        >
                          {(selectedZone?.destinations || []).map((dest) => (
                            <Option key={dest._id} value={dest._id}>
                              {dest.name} — ₹{Number(dest.amount).toLocaleString("en-IN")}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                      {selectedDest && (
                        <div style={{ marginTop: -12, marginBottom: 16 }}>
                          <Tag color="blue" style={{ fontSize: 13 }}>
                            Fee: ₹{Number(selectedDest.amount).toLocaleString("en-IN")} / year
                          </Tag>
                        </div>
                      )}
                    </div>
                  )}
                  {transportationCheckbox && (
                    <div className="mt-4" style={{ borderTop: "1px solid #e8e8e8", paddingTop: 16 }}>
                      <div className="font-medium text-gray-600 mb-3" style={{ fontSize: 13 }}>Bus Tracking (Live Tracking App)</div>
                      <div className="grid grid-cols-2 gap-x-4">
                        <Form.Item label="Route" name="route_id" className="w-full">
                          <Select
                            showSearch
                            showArrow
                            allowClear
                            placeholder="Select Route"
                            className="w-full"
                            loading={routes.isLoading}
                            onChange={(value) => {
                              setRouteId(value || null);
                              form.resetFields(["route_entry_point_id"]);
                            }}
                          >
                            {(routes.data || []).map((route) => (
                              <Option key={route._id} value={route._id}>
                                {route.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                        <Form.Item label="Entry Point" name="route_entry_point_id" className="w-full">
                          <Select
                            showSearch
                            showArrow
                            allowClear
                            placeholder={routeId ? "Select entry point" : "Select a route first"}
                            className="w-full"
                            disabled={!routeId}
                          >
                            {(routesDetail.data || []).map((stop) => (
                              <Option key={stop._id} value={stop._id}>
                                {stop.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  )}

                  <Title level={4} className="admission-subheading">
                    Accommodation
                  </Title>
                  <Form.Item
                    name="is_accommodation_required"
                    valuePropName="checked"
                  >
                    <Checkbox
                      onChange={(e) => {
                        setAccommodationCheckbox(e.target.checked);
                      }}
                      checked={accommodationCheckbox}
                    >
                      Accommodation require?
                    </Checkbox>
                  </Form.Item>
                  {accommodationCheckbox && !data?.is_accommodation_required && (
                    <Alert
                      type="warning"
                      showIcon
                      message="Action required after saving"
                      description="After saving these changes, go to the Fee Template and apply it again to generate the accommodation fee for this student."
                      style={{ marginBottom: 16 }}
                    />
                  )}
                </Panel>

                <Panel header="5. Father's Details" key="father">
                  <div className="grid grid-cols-2 gap-x-4">
                    <Form.Item
                      name="primary_contact_first_name"
                      label="First Name"
                      className="w-30"
                      rules={[
                        {
                          required: true,
                          message: "First name is required",
                        },
                        {
                          validator: validateAlphabetsOnly,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name="primary_contact_last_name"
                      label="Last Name"
                      className="w-30"
                      rules={[
                        {
                          required: true,
                          message: "Last name is required",
                        },
                        {
                          validator: validateAlphabetsOnly,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </div>
                  <div className="grid grid-cols-2 gap-x-4">
                    <Form.Item
                      name="primary_contact_phone"
                      label="Phone"
                      className="w-30"
                      rules={[
                        {
                          required: true,
                          message: "Phone is required",
                        },
                        {
                          pattern: /^[0-9]{10}$/,
                          message: "Please enter a valid 10-digit phone number!",
                        },
                      ]}
                      getValueFromEvent={(e) => e.target.value.slice(0, 10)}
                    >
                      <Input type="number" maxLength={10} min={0} {...numberInputGuard} />
                    </Form.Item>
                    <Form.Item
                      name="primary_contact_email"
                      label="Email"
                      className="w-30"
                      rules={[
                        {
                          type: "email",
                          message: "Please enter a valid email",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </div>
                  <div className="grid grid-cols-2 gap-x-4">
                    <Form.Item
                      name="primary_contact_relation"
                      label="Relation"
                      className="w-30"
                      rules={[
                        {
                          required: true,
                          message: "Relation is required",
                        },
                        {
                          validator: validateAlphabetsOnly,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name="primary_contact_aadhar"
                      label="Aadhar"
                      className="w-30"
                      rules={[
                        {
                          pattern: /^[0-9]{12}$/,
                          message: "Please enter a valid 12-digit Number!",
                        },
                      ]}
                      getValueFromEvent={(e) => e.target.value.slice(0, 12)}
                    >
                      <Input maxLength={12} type="number" min={0} {...numberInputGuard} />
                    </Form.Item>
                  </div>
                  <div className="grid grid-cols-2 gap-x-4">
                    <Form.Item
                      name="primary_contact_education"
                      label="Education"
                      className="w-30"
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name="primary_contact_occupation"
                      label="Occupation"
                      className="w-30"
                    >
                      <Input />
                    </Form.Item>
                  </div>
                  <div className="grid grid-cols-2 gap-x-4">
                    <Form.Item
                      name="primary_contact_annual_income"
                      label="Annual Income"
                      className="w-30"
                    >
                      <Input />
                    </Form.Item>
                  </div>
                </Panel>

                <Panel header="6. Mother's Details" key="mother">
                  <div className="grid grid-cols-2 gap-x-4">
                    <Form.Item
                      name="mother_name"
                      label="Name"
                      className="w-30"
                      rules={[
                        {
                          validator: validateAlphabetsOnly,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name="mother_phone"
                      label="Phone"
                      className="w-30"
                      rules={[
                        {
                          pattern: /^[0-9]{10}$/,
                          message: "Please enter a valid 10-digit phone number!",
                        },
                      ]}
                      getValueFromEvent={(e) => e.target.value.slice(0, 10)}
                    >
                      <Input type="number" maxLength={10} min={0} {...numberInputGuard} />
                    </Form.Item>
                  </div>
                  <div className="grid grid-cols-2 gap-x-4">
                    <Form.Item
                      name="mother_email"
                      label="Email"
                      className="w-30"
                      rules={[
                        {
                          type: "email",
                          message: "Please enter a valid email",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name="mother_aadhar"
                      label="Aadhar"
                      className="w-30"
                      rules={[
                        {
                          pattern: /^[0-9]{12}$/,
                          message: "Please enter a valid 12-digit Number!",
                        },
                      ]}
                      getValueFromEvent={(e) => e.target.value.slice(0, 12)}
                    >
                      <Input maxLength={12} type="number" min={0} {...numberInputGuard} />
                    </Form.Item>
                  </div>
                  <div className="grid grid-cols-2 gap-x-4">
                    <Form.Item
                      name="mother_education"
                      label="Education"
                      className="w-30"
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name="mother_occupation"
                      label="Occupation"
                      className="w-30"
                    >
                      <Input />
                    </Form.Item>
                  </div>
                  <div className="grid grid-cols-2 gap-x-4">
                    <Form.Item
                      name="mother_annual_income"
                      label="Annual Income"
                      className="w-30"
                    >
                      <Input />
                    </Form.Item>
                  </div>
                </Panel>

                <Panel
                  header={
                    hasGuardianData ? "7. Guardian" : "7. Guardian (if applicable)"
                  }
                  key="guardian"
                >
                  <div className="grid grid-cols-2 gap-x-4">
                    <Form.Item
                      name="secondary_contact_first_name"
                      label="First Name"
                      className="w-30"
                      rules={[
                        {
                          validator: validateAlphabetsOnly,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name="secondary_contact_last_name"
                      label="Last Name"
                      className="w-30"
                      rules={[
                        {
                          validator: validateAlphabetsOnly,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </div>
                  <div className="grid grid-cols-2 gap-x-4">
                    <Form.Item
                      name="secondary_contact_phone"
                      label="Phone"
                      className="w-30"
                      rules={[
                        {
                          pattern: /^[0-9]{10}$/,
                          message: "Please enter a valid 10-digit phone number!",
                        },
                      ]}
                      getValueFromEvent={(e) => e.target.value.slice(0, 10)}
                    >
                      <Input type="number" maxLength={10} min={0} {...numberInputGuard} />
                    </Form.Item>
                    <Form.Item
                      name="secondary_contact_email"
                      label="Email"
                      className="w-30"
                    >
                      <Input />
                    </Form.Item>
                  </div>
                  <div className="grid grid-cols-2 gap-x-4">
                    <Form.Item
                      name="secondary_contact_relation"
                      label="Relation"
                      className="w-30"
                      rules={[
                        {
                          validator: validateAlphabetsOnly,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </div>
                </Panel>
              </Collapse>

              <div className="pb-2 w-96 pt-6">
                <div
                  style={{ color: "#1B1818" }}
                  className="flex flex-row items-center justify-between py-2"
                >
                  <div>Student Status </div>
                </div>
                <Form.Item name="blocked">
                  <Select
                    showSearch
                    showArrow
                    className="w-3/4"
                    placeholder="Student Status"
                    optionFilterProp="children"
                  >
                    <Option value={false} className="text-green-600">
                      Active
                    </Option>
                    <Option value={true} className="text-red-600">
                      Suspend
                    </Option>
                  </Select>
                </Form.Item>
              </div>

              <div className="flex items-center justify-between pt-10 ">
                <div>
                  <Button size="large" type="danger" onClick={confirmDelete}>
                    Delete
                  </Button>
                </div>
                <div className="flex flex-row space-x-4">
                  <Button
                    size="large"
                    type="dark"
                    onClick={() => {
                      form.resetFields();
                    }}
                  >
                    Cancel
                  </Button>

                  <Button
                    size="large"
                    type="primary"
                    htmlType="submit"
                    className="text-white"
                  >
                    Save Changes
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </div>
      </div>
    </>
  );
}

export default StudentSetting;




